// extracted by mini-css-extract-plugin
export default {"goback":"Contactus_goback__k4mzl"};